import { useModalContext } from '../context.mjs';

function useModalContentElement() {
  const { modalContentElement } = useModalContext(
    "Modal/useModalContentElement"
  );
  return modalContentElement;
}

export { useModalContentElement as default };
//# sourceMappingURL=useModalContentElement.mjs.map
